import EllipsisText from '@adsk/nirvana-ellipsis-text';
import { styled, css, boolean, colors } from '@adsk/nirvana-theme';

export const Wrapper = styled.li<{ $disabled?: boolean; $isActive?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  height: 36px;
  padding: 0 8px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.charcoal050};
  }

  ${boolean(
    '$isActive',
    css`
      background-color: ${colors.charcoal050};
    `
  )}

  ${boolean(
    '$disabled',
    css`
      cursor: default;
      opacity: 0.4;

      &:hover {
        background-color: initial;
      }
    `
  )}
`;

export const Ellipsis = styled.div`
  flex: auto;
  margin: 0 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Label = styled(EllipsisText)<{ children?: React.ReactNode }>`
  flex: auto;
  margin: 0 8px;
`;

export const Divider = styled.li`
  display: block;
  height: 1px;
  margin: 2px 0;
  background-color: ${colors.charcoal100};
`;
